import SteveModel from '@shell/plugins/steve/steve-class';

export default class GitRepoRestriction extends SteveModel {

}
